import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { GaleriaVideoService } from './../../../../../monitoreo/services/galeria-video.service';
import { AuthService } from './../../../../../auth/auth.service';
import { DatePipe } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { PlayVideoComponent } from './play-video/play-video.component';
import { StreamVideoComponent } from './stream-video/stream-video.component';
import { InformacionVideo } from './../../../../../../_entities/galeria-videos/informacion-videos';
import { MapaService } from './../../../../../monitoreo/services/mapa.service';


@Component({
	selector: 'kt-galeria-videos',
	templateUrl: './galeria-videos.component.html',
	styleUrls: ['./galeria-videos.component.scss']
})

export class GaleriaVideosComponent implements OnInit {
	private token: string;
	public loadingVisible: boolean = false;
	public arrayVideos = [];
	public listaAlarmas = [
		{ id: 1, fileType: 1, location: 1 , nombre: 'Almacenamiento Dispositivo' },
		{ id: 2, fileType: 2, location: 4,  nombre: 'Puerta Abierta' },
		{ id: 3, fileType: 1,  location: 3,  nombre: 'Auto Descargas' }
	]

	public alarma;
	public startTime;
	public endTime;
	public videoArchivos;
	public deviceID;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public showTable: boolean;
	public esReproduccion: boolean = false;
	public timeline = [];

	customizeText (e) {
        return 'Total de videos: ' + e.value;
    };

	constructor(public dialogRef: MatDialogRef<GaleriaVideosComponent>,
		private galeriaVideoService: GaleriaVideoService,
		private mapaService: MapaService,
		private dialog: MatDialog,
		private toastservice: ToastrService,
		private datepipe: DatePipe,
		private authService: AuthService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private sanitizer: DomSanitizer
	) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
	}

	transform(url) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}

	ngOnInit() {
		this.token = this.authService.getUser().tokenHW;
		if(this.data !== null) {
			this.deviceID = this.data;
		} else {
			this.esReproduccion = true;
			//const DATA = JSON.parse(sessionStorage.getItem('data'));
			this.deviceID = this.data;
			this.startTime = this.mapaService.historicoFechas[0];
			this.endTime = this.mapaService.historicoFechas[1];
			this.alarma = 1;
			this.obtenerArchivos()
		}
	}

	obtenerArchivos() {
		this.videoArchivos = [];
		this.loadingVisible = true;
		const startTime = this.datepipe.transform(this.startTime, 'yyyy-MM-dd HH:MM:SS');
		const endTime = this.datepipe.transform(this.endTime, 'yyyy-MM-dd HH:MM:SS');
		const channelList = '1;2';

		const ALARM = this.listaAlarmas.find(alarma => alarma.id === this.alarma);
		const location = ALARM.location;
		const fileType = ALARM.fileType;

		this.galeriaVideoService.obtenerArchivosVideo(startTime, endTime, channelList, fileType, location, this.deviceID).pipe(
			finalize(
				() => this.loadingVisible = false
			)
		).subscribe(
			(response) => {
				let archivos: InformacionVideo = JSON.parse(response);
				if (archivos.data != null) {
					this.videoArchivos = archivos.data.files;

					if(ALARM.id == 3) {
						this.videoArchivos.map(archivo => {
							archivo.type = 3;
						})
					}

					this.videoArchivos.forEach(video => {
						let timelineForm = {
							deviceID: video.deviceID,
							start: new Date (video.start),
							channel: video.channel,
							stop: new Date(video.stop)
						}

						this.timeline.push(timelineForm);

					});
					this.showTable = true;
				} else {
					this.timeline = [];
					this.videoArchivos = [];
					this.showTable = false;
					this.toastservice.warning('No existen archivos disponibles')
				}
			}, (error) => {
				this.toastservice.error('Error al obtener lista de archivos')
			}
		);
	}

	customizeTooltip(arg: any) {
		//let inicio = this.datepipe.transform(arg.rangeValue1Text, 'dd-MM-yyyy HH:mm a');
        return {
            text: arg.rangeValue1Text
        };
    }

	pointClick(event){
		const data = event.target.data;

		data.start = this.datepipe.transform(data.start, 'yyyy-MM-dd HH:MM:SS');
		data.stop = this.datepipe.transform(data.stop, 'yyyy-MM-dd HH:MM:SS');

		this.abrirVideo(data);
	}

	abrirVideo(videoInfo) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "40%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = videoInfo
		this.dialog.open(PlayVideoComponent, dialogConfig);
	}

	abrirStream() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "40%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = this.deviceID
		this.dialog.open(StreamVideoComponent, dialogConfig);

	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
